<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main">
                <div class="container">
                    <el-form class="dataFormBox" :inline="true" :model="dataForm">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票用途：">
                                    <el-select v-model="dataForm.billUsage" placeholder="请选择发票用途">
                                        <el-option label="工程款支付" value="PROJECT_PAY"></el-option>
                                        <el-option label="费用报销" value="COST"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="项目部：">
                                    <el-select v-model="dataForm.deptName" placeholder="请选择项目部"  @change="getProjectList">
                                        <el-option :label="deptItem.applyDeptName" :value="deptItem" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="项目名称：">
                                    <el-select v-model="dataForm.projectName" placeholder="请选择项目名称" @change="getSubInfoList">
                                        <el-option :label="projectItem.name" :value="projectItem" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="分项合同：">
                                    <el-select v-model="dataForm.subContractName" placeholder="请选择分项合同" @change="setSubInfo">
                                        <el-option :label="subItem.name" :value="subItem" v-for="(subItem,subIndex) in subInfoList" :key="'subItem'+subIndex"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票类型：">
                                    <el-select v-model="dataForm.billType" placeholder="请选择发票类型">
                                        <el-option label="增值税专用发票" value="VAT"></el-option>
                                        <el-option label="普通发票" value="PLAIN"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票种类：">
                                    <el-select v-model="dataForm.billInvoiceType" placeholder="请选择发票种类">
                                        <el-option label="电子发票" value="ELECTRONIC"></el-option>
                                        <el-option label="纸质发票" value="PAPER"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票抬头：">
                                    <el-input v-model="dataForm.billHead" placeholder="请输入发票抬头" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="纳税人识别号：">
                                    <el-input v-model="dataForm.taxPayerCode" placeholder="请输入纳税人识别号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票号码：">
                                    <el-input v-model="dataForm.billNumber" placeholder="请输入发票号码" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票代码：">
                                    <el-input v-model="dataForm.billCode" placeholder="请输入发票代码" clearable></el-input>
                                </el-form-item>
                            </el-col>
<!--                            <el-col :span="12">-->
<!--                                <el-form-item label-width="120px" label="不含税金额：">-->
<!--                                    <el-input v-model="dataForm.amountWithoutTax" placeholder="请输入不含税金额" clearable-->
<!--                                              @input="limitInput($event,'amountWithoutTax')"-->
<!--                                              @blur="setPriceNum"></el-input>-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->
<!--                            <el-col :span="12">-->
<!--                                <el-form-item label-width="120px" label="税额：">-->
<!--                                    <el-input v-model="dataForm.tax" placeholder="请输入税额" clearable-->
<!--                                              @input="limitInput($event,'tax')"-->
<!--                                              @blur="setPriceNum"></el-input>-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="税率：">
                                    <el-input v-model="dataForm.taxRate" placeholder="请输入税率" clearable
                                              @input="limitInput($event,'taxRate')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="120px" label="发票金额：">
                                    <el-input v-model="dataForm.amount" placeholder="请输入发票金额" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label-width="120px" label="附件：">
                                    <el-upload
                                            class="upload-demo"
                                            :action="actionUrl"
                                            :headers="importHeaders"
                                            :data="uploadData"
                                            :limit = '1'
                                            :on-success="handleSuccess"
                                            :on-remove="handleRemove"
                                            :file-list="fileList"
                                            list-type="picture">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </el-main>
            <el-footer class="container">
                <div class="btnMid">
                    <el-button type="primary" @click="submit()">提 交</el-button>
                    <el-button type="info" @click="reset()">取 消</el-button>
                </div>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import {
        getInputBillService,
        getDeptListService,
        getProjectListService,
        querySubInfoByProjectIdService,
        submitInputBillService,
        putInputBillService,
        getTempUrlService,
    } from '@/services/invoiceServices'
    import config from "@/common/config";
    export default {
        name: "income-input",
        data(){
            return {
                dataForm:{
                    billUsage:'',
                    deptId:'',
                    deptName:'',
                    projectId:'',
                    projectName:'',
                    subContractId:'',
                    subContractName:'',
                    billInvoiceType:'',
                    billType:'',
                    billHead:'',
                    taxPayerCode:'',
                    billNumber:'',
                    billCode:'',
                    taxRate:'',
                    amount:'',
                    attachUrl:'',
                },
                actionUrl:'', //上传地址
                importHeaders:{
                    Authorization: sessionStorage.getItem('accessToken')
                },//上传请求头
                uploadData: {
                    category:'INPUT',
                },
                fileList:[],
                deptList:[], //项目部列表
                projectList:[], //项目列表
                subInfoList:[], //分项合同列表
                id: '',
            }
        },
        methods:{
            onActive(menuCode) {
                this.id = this.tabRouteParam.id
                console.log(this.id);
                this.actionUrl = config.baseUrl+'/finance-web/oss/upload/finance/singleItem';
                this.getDeptList();
            },
            /**
             *  获取发票详情
             * */
            getIncomeDetail(){
                let params = {
                    id: this.id
                }
                getInputBillService(params).then( res => {
                    if(res.code == 10000000){
                        console.log(res)
                        this.dataForm = {
                            billUsage: res.data.billUsage,
                            deptId: res.data.deptId,
                            deptName: res.data.deptName,
                            projectId: res.data.projectId,
                            projectName: res.data.projectName,
                            subContractId: res.data.subContractId,
                            subContractName: res.data.subContractName,
                            billInvoiceType: res.data.billInvoiceType,
                            billType: res.data.billType,
                            billHead: res.data.billHead,
                            taxPayerCode: res.data.taxPayerCode,
                            billNumber: res.data.billNumber,
                            billCode: res.data.billCode,
                            taxRate: res.data.taxRate,
                            amount: res.data.amount,
                            attachUrl: res.data.attachUrl,
                        }
                        if(res.data.attachUrl){
                            this.getTempUrl(res.data.attachUrl);
                        }
                        this.getProjectListId();
                        this.getSubInfoListId();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /***
             * 获取图片路径
             */
            getTempUrl(url){
                let params = {
                    filePath: url
                }
                getTempUrlService(params).then( res => {
                    if(res.code == 10000000){
                        this.fileList.push({name: '', url: res.data});
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                        if(this.id){
                            this.getIncomeDetail();
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 获取项目列表
             * */
            getProjectList(item){
                console.log(item)
                this.dataForm.deptId = item.applyDeptId;
                this.dataForm.deptName = item.applyDeptName;
                this.dataForm.projectId = '';
                this.dataForm.projectName = '';
                this.subInfoList = [];
                this.dataForm.subContractId = '';
                this.dataForm.subContractName = '';
                this.getProjectListId();
            },
            getProjectListId(){
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 获取分项合同列表
             * */
            getSubInfoList(item){
                this.dataForm.projectId = item.id;
                this.dataForm.projectName = item.name;
                this.dataForm.subContractId = '';
                this.dataForm.subContractName = '';
                this.getSubInfoListId();
            },
            getSubInfoListId(){
                let paramsData = {
                    projectId: this.dataForm.projectId
                }
                querySubInfoByProjectIdService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.subInfoList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 设置选择的分项合同数据
            setSubInfo(item){
                this.dataForm.subContractId = item.id;
                this.dataForm.subContractName = item.name;
            },
            submit(){
                let params = {
                    ...this.dataForm,
                    source: 'WEB'
                }
                if(this.id){
                    params.id = this.id;
                    this.putInputBill(params);
                }else{
                    this.setInputBill(params);
                }
            },
            reset(){
                this.bus.$emit("tabClose", "incomeInput");
                this.bus.$emit("navMenuChange", {
                    routeId: "incomeInvoice"
                });
            },
            /**
             * 提交申请
             * */
            setInputBill(params){
                submitInputBillService(params).then( res => {
                    if(res.code == 10000000){
                        this.$message.success('发票录入成功');
                        this.reset();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            putInputBill(params){
                putInputBillService(params).then( res => {
                    if(res.code == 10000000){
                        this.$message.success('发票修改成功');
                        this.reset();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            handleRemove(file, fileList) {
                this.dataForm.attachUrl = '';
            },
            handleSuccess(res, file, fileList) {
                this.dataForm.attachUrl = res.data.resource;
            },


            // 只能输入数字和后两位小数
            limitInput(value, name) {
                let val = (value && value.split("")) || [];
                let reg1 = /\d/;
                let reg2 = /\./;
                // 第一个字符不能为小数点
                if (val[0] == ".") {
                    this.dataForm[name] = "";
                    return;
                }
                // 过滤掉除数字和小数点外的字符
                val = val.filter((e) => reg1.test(e) || reg2.test(e));
                // 匹配小数点后只能有两位小数
                // 解释一下这个match正则规格
                // ^\d* 是指以数字开头，后面允许输入0到多位数字
                // (\.?) 是指只允许一个小数点
                // \d{0,2} 是指只允许0到2位小数
                this.dataForm[name] = val.join("").match(/^\d*(\.?\d{0,2})/g)[0] || null;
            },
        }
    }
</script>


<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
        }
        .containerBox{
            width: 1100px;
        }
    }
    /deep/.el-container .el-main{
        height: 100%;
    }
    /deep/.el-textarea{
        width: 600px;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    /deep/.upload-demo{
        display: flex;
        align-items: center;
        .el-icon-close:before{
            color: #000000;
        }
        .el-upload-list__item{
            margin-top: 0px;
            margin-left: 10px;
        }
        .el-upload-list__item-name{
            margin-right: 0px;
            width: 75px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 20px;
    }
    .btnMid {
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }
    .addBtn {
        width: 30px;
        height: 30px;
    }
</style>

